
import { Options, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { LayoutMixin } from "@/mixins/LayoutMixin";
import { namespace } from "vuex-class";
import Header from "@/components/layout/Header.vue";

const AuthModule = namespace("auth");

@Options({
  components: { Header },
})
export default class DefaultLayout extends mixins(LayoutMixin) {
  @AuthModule.Getter("getDataItem")
  private user: any;

  @AuthModule.Action("setIsConsumerView")
  protected setIsConsumerViewAction: any;

  @AuthModule.Action("signOut")
  protected signOutAction: any;

  private v: any = 3;
  private isCollapse = false;

  private showAside = false;

  private sidebarItems = [
    {
      label: "Benutzer",
      icon: "pi pi-fw pi-user",
      url: "user",
      routeName: "UserList",
    },
    {
      label: "Seiten",
      icon: "pi pi-fw pi-book",
      url: "page",
      routeName: "PageList",
    },
    {
      logout: true,
      label: "Ausloggen",
      icon: "pi pi-fw pi-power-off",
      url: "page",
      routeName: "PageList",
    },
  ];

  public getValue(e: any) {
    this.v = e.target._value.id;
  }
  private onShowAsideChange(value: boolean): void {
    this.showAside = value;
  }

  mounted() {
    if (localStorage.getItem("menuCollapsed")) {
      this.isCollapse =
        localStorage.getItem("menuCollapsed") === "false" ? false : true;
    }
  }

  private toRoute(routeName: string): void {
    this.$router.push({ name: routeName });
  }

  private logout(): void {
    this.signOutAction();
  }

  public onChangeCollapse() {
    localStorage.setItem("menuCollapsed", !this.isCollapse + "");
  }

  @Watch("isCollapse", { immediate: true })
  public onUpdate(newVal: boolean) {
    return newVal;
  }

  @Watch("$route", { immediate: true })
  public routeChanged(val: any) {
    if (localStorage.getItem("menuCollapsed")) {
      this.isCollapse =
        localStorage.getItem("menuCollapsed") === "true" ? true : false;
    }
  }
}
